<script setup lang="ts">
import { computed } from 'vue';
import AdpDocumentSourceBadge from '@/components/common/article/adp-document-source-badge.vue';
import { useInsightTracking } from '@/components/home/insights/use-insight-tracking';
import { AdpDocument } from '@/types';
import type { InsightSourceContext } from '@/types/insights';

type InsightSourceLocation =
  | { source_location: 'topic'; topicId: number }
  | {
      source_location: 'hypothesis_reason';
      hintId: number;
      hypothesisReasonId: number;
    };

interface Props {
  position: number;
  adpDocument: AdpDocument;
  insightSourceId: number;
  location: InsightSourceLocation;
  variant?: 'white' | 'gray';
}

const props = withDefaults(defineProps<Props>(), { variant: 'white' });

const { pageName, insightId, axisId, axisName } = useInsightTracking();

const insightSourceContext = computed<InsightSourceContext>(() =>
  props.location.source_location === 'topic'
    ? {
        source_location: 'topic',
        insight: { id: insightId },
        axis: { id: axisId, name: axisName },
        topic: { id: props.location.topicId },
        source: { id: props.insightSourceId },
      }
    : {
        source_location: 'hypothesis_reason',
        insight: { id: insightId },
        axis: { id: axisId, name: axisName },
        hint: { id: props.location.hintId },
        hypothesis_reason: { id: props.location.hypothesisReasonId },
        source: { id: props.insightSourceId },
      },
);
</script>

<template>
  <AdpDocumentSourceBadge
    class="insight-source"
    :position="position"
    :adp-document="adpDocument"
    :page-name="pageName"
    feature="insight"
    :insight-source-context="insightSourceContext"
    :variant="variant"
  />
</template>
